import $ from 'jquery';

const $coll = $('#cfrColl');
const $tvList = $coll.find('.list_thumb li');
const $pagingNav = $coll.find('.paging_nav');
const listViewCount = 4; // 리스트 아이템 갯수
const wideListViewCount = 3; // 리스트 아이템 갯수
const $body = $('body');
const pagingHideNum = $body.hasClass('wide')?wideListViewCount:listViewCount;


// 리스트 페이징
const pager = new SF.pager({
  navigation: $pagingNav,
  list: $tvList,
  viewCount: listViewCount,
  wideViewCount: wideListViewCount,
  isInfinite: false
});

// 아이템 갯수 wide에 유무 따라 3||4 개 이하면 페이징 숨김.
if($tvList.length <= pagingHideNum){
  $pagingNav.addClass('hide');
}

//총페이지수 재설정
$coll.find('.paging_nav .total_page').text(Math.ceil($tvList.length/listViewCount));




/** WEBPACK FOOTER **
 ** ./src/CFR/index.js
 **/